// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SkhZ","newExpiryDate":"styles_newExpiryDate__3SjSh","footer":"styles_footer__meLA1"};